import Image from 'next/image';
import { useState } from 'react';
import { PromoStyle, PromoVariant } from '../../constants/PromoVariant';
import { renderColor } from '../../util/ColorUtil';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import CtaBarButton from '../base/cta-bar-button';
import FacilityModal from '../modal/FacilityModal';
import { Constants } from '../../util/Constants';
import { cleanHTML } from '../utils/htmlUtils';
import { useRouter } from 'next/router';

const TemplateImage = ({ children, lang, global }) => {
  const sources =
    Constants.cloudinaryImage + children.field_template_image.webimage;
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  const emphasizedTextColor = getEditorColors(
    isItUndefined(children?.field_long_formatted),
    isItUndefined(children?.field_description)
  ).filter((x) => x)[0];
  const { locale } = useRouter();

  return (
    <>
      {children?.field_variant[0]?.value != PromoVariant.PROMO_AREA ? (
        children.field_template_image.webimage ? (
          <div
            style={{
              backgroundImage: sources
                ? 'linear-gradient(180deg, rgba(0, 0, 0, 0) 37.37%, rgba(0, 0, 0, 0.8) 100%), url(' +
                  sources +
                  ')'
                : '',
            }}
            className={'template-image'}
          >
            <span className={'title'}>
              {children.field_template_image_title[0]?.value}
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  modifyLinks(children?.field_long_formatted[0]?.value, locale)
                ),
              }}
              className={'subtitle'}
            ></div>
          </div>
        ) : null
      ) : (
        <div
          className={`template-image-promo-area ${renderColor(children?.field_text_color[0]?.value)}`}
        >
          {children?.field_styles[0]?.value == PromoStyle.STYLE_1 ? (
            <div className="double-image-container">
              <div className="left">
                <Image
                  objectPosition="center"
                  objectFit="cover"
                  layout="fill"
                  alt="template-image"
                  src={children.field_template_image.webimage}
                />
              </div>
              <div className="right">
                {children?.field_second_image.webimage && (
                  <div className="second-image">
                    <Image
                      objectFit="cover"
                      layout="fill"
                      alt="template-image"
                      src={children.field_second_image.webimage}
                    />
                  </div>
                )}
                <div className="text-container">
                  {isItUndefined(children?.field_template_image_title) && (
                    <p className="title">
                      {isItUndefined(children?.field_template_image_title)}
                    </p>
                  )}
                  {isItUndefined(children?.field_long_formatted) && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: cleanHTML(
                          modifyLinks(
                            children?.field_long_formatted[0]?.value,
                            locale
                          )
                        ),
                      }}
                      className={`subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                    ></div>
                  )}
                  {isItUndefined(children?.field_description) && (
                    <span
                      className={`description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                      dangerouslySetInnerHTML={{
                        __html: cleanHTML(
                          modifyLinks(
                            children?.field_description[0]?.value,
                            locale
                          )
                        ),
                      }}
                    ></span>
                  )}
                  {children?.field_cta_bar_button_selection?.length > 0 && (
                    <CtaBarButton
                      blockTypeClass={'template-image'}
                      bgColor={renderColor(
                        children?.field_text_color[0]?.value,
                        null
                      )}
                      setMarketoTrigger={setMarketoTrigger}
                      data={
                        children?.field_cta_bar_button_selection[0]
                          ?.cta_bar_button
                      }
                      pathname={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="single-image-container">
              <div className="left">
                <div className="inner-container">
                  <div
                    className={`text-container${children?.field_styles[0]?.value == PromoStyle.STYLE_3 ? ' rotated' : ''}`}
                  >
                    {isItUndefined(children?.field_template_image_title) && (
                      <p className="title">
                        {isItUndefined(children?.field_template_image_title)}
                      </p>
                    )}
                    {isItUndefined(children?.field_long_formatted) && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: cleanHTML(
                            modifyLinks(
                              children?.field_long_formatted[0]?.value,
                              locale
                            )
                          ),
                        }}
                        className={`subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                      ></div>
                    )}
                    {isItUndefined(children?.field_description) && (
                      <span
                        className={`description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                        dangerouslySetInnerHTML={{
                          __html: cleanHTML(
                            modifyLinks(
                              children?.field_description[0]?.value,
                              locale
                            )
                          ),
                        }}
                      ></span>
                    )}
                    {children?.field_cta_bar_button_selection?.length > 0 && (
                      <CtaBarButton
                        blockTypeClass={'template-image'}
                        bgColor={renderColor(
                          children?.field_text_color[0]?.value,
                          null
                        )}
                        setMarketoTrigger={setMarketoTrigger}
                        data={
                          children?.field_cta_bar_button_selection[0]
                            ?.cta_bar_button
                        }
                        pathname={true}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="inner-container">
                <div
                  className={`right${children?.field_styles[0]?.value == PromoStyle.STYLE_3 ? ' rotated' : ''}`}
                >
                  <Image
                    objectPosition="center"
                    objectFit="cover"
                    layout="fill"
                    alt="template-image"
                    src={children?.field_template_image?.webimage}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {marketoTrigger && (
        <FacilityModal
          lang={lang}
          global={global}
          setTrigger={setMarketoTrigger}
          trigger={marketoTrigger}
        >
          {
            children?.field_cta_bar_button_selection[0]?.cta_bar_button
              ?.field_marketo_blocks[0]?.marketo_form_facility_block_type
          }
        </FacilityModal>
      )}
    </>
  );
};

export default TemplateImage;
